var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEmail, IsOptional, IsString, MaxLength, ValidateIf } from 'class-validator';
import { IsValidBic, IsValidIban, IsValidTaxNumber, IsValidVatId } from '../validators/index.js';
export class UpdateOfficeLocationBillingDetailsDto {
    taxNumber;
    vatId;
    iban;
    bic;
    bankName;
    invoiceFooter;
    invoiceEmailSender;
    isSmallBusiness;
}
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsValidTaxNumber(),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "taxNumber", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsValidVatId(),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "vatId", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsValidIban(),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "iban", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsValidBic(),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "bic", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "bankName", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsString(),
    MaxLength(500),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "invoiceFooter", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsEmail(),
    __metadata("design:type", Object)
], UpdateOfficeLocationBillingDetailsDto.prototype, "invoiceEmailSender", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationBillingDetailsDto.prototype, "isSmallBusiness", void 0);
//# sourceMappingURL=update-office-location-billing-details.dto.js.map